import { get } from "../../service/api";

const GetSbIncomeDetail = async (date) => {
  try {
    const response = await get(`/admin/sbIncomeDetail?date=${date}`);
    return response;
  } catch (error) {
    console.error("Error admin GetSbIncomeDetail:", error);
    throw error;
  }
};

export default GetSbIncomeDetail;
